import React from 'react';

import { WorksheetPageIndex } from 'services/worksheet/types';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import Bold from 'components/Bold';
import PrintSprayWorksheetProductsTable from './components/PrintSprayWorksheetProductsTable';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default class PrintSprayWorksheetProducts extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex } = this.props;

        return (
            <div className="print-worksheet-page-section">
                <Grid columns="1">
                    <GridRow>
                        <GridColumn>
                            <Bold>Product details</Bold>
                        </GridColumn>
                    </GridRow>
                </Grid>
                <PrintSprayWorksheetProductsTable pageIndex={pageIndex} />
            </div>
        );
    }
}
